import { render, staticRenderFns } from "./AppReviewLikeSection.vue?vue&type=template&id=6f8afb73&scoped=true"
import script from "./AppReviewLikeSection.vue?vue&type=script&lang=js"
export * from "./AppReviewLikeSection.vue?vue&type=script&lang=js"
import style0 from "./AppReviewLikeSection.vue?vue&type=style&index=0&id=6f8afb73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8afb73",
  null
  
)

/* custom blocks */
import block0 from "./AppReviewLikeSection.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)
import block1 from "./AppReviewLikeSection.vue?vue&type=custom&index=1&blockType=i18n&locale=en"
if (typeof block1 === 'function') block1(component)
import block2 from "./AppReviewLikeSection.vue?vue&type=custom&index=2&blockType=i18n&locale=ja"
if (typeof block2 === 'function') block2(component)
import block3 from "./AppReviewLikeSection.vue?vue&type=custom&index=3&blockType=i18n&locale=zh-CN"
if (typeof block3 === 'function') block3(component)
import block4 from "./AppReviewLikeSection.vue?vue&type=custom&index=4&blockType=i18n&locale=zh-TW"
if (typeof block4 === 'function') block4(component)

export default component.exports